export default function initPopup() {
  const popup = document.querySelector(".popup");
  const wrapper = document.querySelector(".popup-wrapper");
  const closeBtn = document.querySelector(".popup-close");
  if (!popup || !wrapper || !closeBtn) return;

  function openPopup() {
    popup.classList.add("show");
    document.documentElement.style.overflow = "hidden";
  }

  function closePopup() {
    popup.classList.remove("show");
    document.documentElement.style.overflow = "";
  }

  setTimeout(openPopup, 2000);

  closeBtn.addEventListener("click", closePopup);

  popup.addEventListener("click", (e) => {
    if (!wrapper.contains(e.target)) {
      closePopup();
    }
  });
}
